import axios from "axios";
import { handleAxiosError } from "../utils/errorHandler";

const axiosInstance = axios.create({
  baseURL: "", 
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

const saveAccessToken = (accessToken) => {
  if (accessToken) localStorage.setItem("accessToken", accessToken);
};

const failed = (error, fallback) => {
  const { status, message } = handleAxiosError(error, fallback);
  return { success: false, status, message };
};

export const loginWithPassword = async (login, password) => {
  try {
    const response = await axiosInstance.post("/api/auth/login-password", {
      login,
      password,
    });
    if (response.data?.mfaRequired) {
      return {
        success: true,
        mfaRequired: true,
        mfaTyp: response.data.mfaTyp,
      };
    }

    saveAccessToken(response.data?.accessToken);
    return { success: true, token: response.data?.accessToken };
  } catch (error) {
    return failed(error, "Přihlášení se nezdařilo. Zkuste to prosím později.");
  }
};

export const verifyLoginMfa = async (code) => {
  try {
    const response = await axiosInstance.post("/api/auth/verify-login-mfa", { code });
    saveAccessToken(response.data?.accessToken);
    return { success: true, token: response.data?.accessToken };
  } catch (error) {
    return failed(error, "Ověření MFA se nezdařilo.");
  }
};

export const requestCode = async (email, mode) => {
  try {
    await axiosInstance.post("/api/auth/request-email-code", {
      email: email.trim(),
      mode,
    });
    return { success: true };
  } catch (error) {
    return failed(error, "Ověřovací kód se nepodařilo odeslat.");
  }
};

export const verifyCode = async (email, code) => {
  try {
    await axiosInstance.post("/api/auth/verify-code", {
      contact: email.trim(),
      code,
    });
    return { success: true };
  } catch (error) {
    return failed(error, "Ověřovací kód není platný.");
  }
};

export const registerUser = async (registration) => {
  try {
    const response = await axiosInstance.post("/api/auth/register-user", registration);
    saveAccessToken(response.data?.accessToken);
    return { success: true, token: response.data?.accessToken };
  } catch (error) {
    return failed(error, "Registrace se nezdařila. Zkuste to prosím později.");
  }
};

export const validateRegistrationCustomer = async (cisloOdberatele, email) => {
  try {
    await axiosInstance.post("/api/auth/validate-registration", {
      cisloOdberatele,
      email,
    });
    return { success: true };
  } catch (error) {
    return failed(error, "Ověření odběratele se nezdařilo.");
  }
};

export const loginWithEmail = async (email) => {
  try {
    const response = await axiosInstance.post("/api/auth/login-email", { email });
    return { success: true, data: response.data };
  } catch (error) {
    return failed(error, "Přihlášení e-mailem se nezdařilo.");
  }
};

export const loginUser = async (cisloOdberatele) => {
  try {
    await axiosInstance.post("/api/auth/login-user", { cisloOdberatele });
    return { success: true };
  } catch (error) {
    return failed(error, "Výběr odběratele se nezdařil.");
  }
};

export const getUsersByEmail = async (email) => {
  try {
    const response = await axiosInstance.get(`/api/auth/users/${encodeURIComponent(email)}`);
    return { success: true, data: response.data };
  } catch (error) {
    return failed(error, "Chyba při načítání odběratele.");
  }
};

export const setNewPassword = async (email, cisloOdberatele, password) => {
  try {
    await axiosInstance.post("/api/auth/set-password", {
      email,
      cisloOdberatele,
      password,
    });
    return { success: true };
  } catch (error) {
    return failed(error, "Heslo se nepodařilo změnit.");
  }
};

export const isTokenValid = async (token) => {
  try {
    await axiosInstance.get("/api/customer/me", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { success: true };
  } catch (error) {
    const result = failed(error, "Ověření přihlášení se nezdařilo.");
    if (result.status === 401) localStorage.removeItem("accessToken");
    return result;
  }
};

export const logout = async () => {
  localStorage.removeItem("accessToken");
  try {
    await axiosInstance.post("/api/auth/logout");
    return { success: true };
  } catch (error) {
    return failed(error, "Odhlášení se nezdařilo.");
  }
};
